import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Interactive from '../views/Interactive.vue'
import PlayRoutine from '../views/PlayRoutine.vue'
import HelpCenter from '../views/HelpCenter.vue'
import Account from '../views/Account.vue'
import HelpDetail from '../views/HelpDetail.vue'
import SuccessPage from '../views/SuccessPage.vue'
import UserLogout from '../views/UserLogout.vue'


import store from '../store'
import { Message } from 'element-ui';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/interactive',
    name: 'Interactive',
    component: Interactive,
  },
  {
    path: '/playRoutine',
    name: 'PlayRoutine',
    component: PlayRoutine,
  },
  {
    path: '/helpCenter',
    name: 'HelpCenter',
    component: HelpCenter,
  },
  {
    path: '/helpDetail',
    name: 'HelpDetail',
    component: HelpDetail,
  },
  {
    path: '/account',
    name: 'Account',
    component: Account,
  },
  {
    path: '/successPage',
    name: 'SuccessPage',
    component: SuccessPage,
  },
  {
    path: '/userLogout',
    name: 'UserLogout',
    component: UserLogout,
  }
]


const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
  // mode:'history'
})

// router.beforeEach((to, from, next) => {
//   const token = localStorage.getItem('token');
//   if (to.path == "/") {
//     //如果用户要访问的是 /logonView 路由，则直接放行
//     next();
//   } else {
//     //否则，检查用户是否已经登录（这里通过检查 sessionStorage 中是否有特定的数据来判断），如果已登录则放行，否则弹出一个提示框告知用户需要登录，并将路由切换到 /logonView
//     if (token) { //存储登录
//       next();
//     } else {
//       Message.error('请重新登录');
//       next("/");
//     }
//   }
// })
export default router
